import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../context/AuthContext";
import http from "../services/httpServices";
import page from "../services/pageServices";
import InputIcon from "../components/form/elements/InputIcon";
import {
    isMultiYear,
    loginPageColor,
    registerPageColor,
    registerPageIcon,
} from "../services/defaultSettings";
import { years } from "../services/yearSevices";
import {
    getFormData,
    handleFormErrors,
    handleFormSubmit,
    handleInputChange as handleChange,
    renderInputFields,
} from "../services/formServices";
import { useLocation, useNavigate } from "react-router-dom";
import auth from "../services/authServices";
import modal from "../services/modalServices";
import SigningForm from "../components/form/singingForm/SigningForm";
import InputField from "../components/form/elements/InputField";
import a from "../services/analyticsServices";

import registerPicture from "../assets/Updated-imagery/Register.jpg";
import Button from "../components/ui/Button";

const AccountCreationRequest = () => {
    const [governments, setGovernments] = useState([]);

    const [user, setUser] = useState({
        first_name: "",
        second_name: "",
        third_name: "",
        last_name: "",
        phone: "",
        father_phone: "",
        mother_phone: "",
        school_name: "",
        master_job: "",
        government_id: "",
        year: 3,
        email: "",
        password: "",
        password_confirmation: "",
        national_id_copy: "",
    });
    const [errors, setErrors] = useState({});

    const [isLoading, setIsLoading] = useState(false);

    const { setAccountRequest } = useContext(AuthContext);

    async function getGovernments() {
        const { data } = await http.get("/api/governments");
        setGovernments(data);
        // user["government_id"] = data[0]["value"];
        // setUser(user);
    }
    useEffect(() => {
        getGovernments();
        const currentTitle = page.getCurrentTitle();
        page.setTitle("طلب انشاء حساب");
        return () => {
            page.setTitle(currentTitle);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let inputFields = [
        {
            id: "first_name",
            placeholder: `الاسم الأول`,
            icon: <InputIcon icon="icon-park-solid:edit-name" />,
            handleChange: (e) => handleChange(e, "first_name", user, setUser, 0, setErrors, true),
        },
        {
            id: "second_name",
            placeholder: `الاسم الثاني`,
            icon: <InputIcon icon="icon-park-solid:edit-name" />,
            handleChange: (e) => handleChange(e, "second_name", user, setUser, 0, setErrors, true),
        },
        {
            id: "third_name",
            placeholder: `الاسم الثالث`,
            icon: <InputIcon icon="icon-park-solid:edit-name" />,
            handleChange: (e) => handleChange(e, "third_name", user, setUser, 0, setErrors, true),
        },
        {
            id: "last_name",
            placeholder: `الاسم الأخير`,
            icon: <InputIcon icon="icon-park-solid:edit-name" />,
            handleChange: (e) => handleChange(e, "last_name", user, setUser, 0, setErrors, true),
        },
    ];

    inputFields = [
        ...inputFields,
        {
            id: "phone",
            placeholder: "رقم الهاتف",
            icon: <InputIcon icon="ant-design:phone-filled" />,
            // className: "lg:col-span-2",
        },
        {
            element: "html",
            input: (
                <p className="text-sm w-full text-orange-600 font-medium mb-2">
                    📌 من فضلك سجل برقم يكون جاهز لاستقبال المكالمات ورسائل{" "}
                    <span className="font-bold">الواتساب</span> والرسائل القصيرة.
                </p>
            ),
            className: "lg:col-span-2",
        },
        {
            id: "father_phone",
            placeholder: "رقم هاتف ولي الأمر",
            icon: <InputIcon icon="ant-design:phone-filled" />,
        },
        {
            element: "html",
            input: (
                <p className="text-sm w-full text-orange-600 font-medium mb-2">
                    📌 من فضلك سجل برقم يكون جاهز لاستقبال المكالمات ورسائل{" "}
                    <span className="font-bold">الواتساب</span> والرسائل القصيرة.
                </p>
            ),
            className: "lg:col-span-2",
        },
        // {
        //     id: "mother_phone",
        //     placeholder: "رقم هاتف الأم",
        //     icon: <InputIcon icon="ant-design:phone-filled" />,
        // },
        // {
        //     id: "school_name",
        //     placeholder: "اسم المدرسة",
        //     icon: <InputIcon icon="ic:twotone-school" />,
        // },
        // {
        //     id: "master_job",
        //     placeholder: `مهنة ولي الأمر`,
        //     icon: <InputIcon icon="ph:bag-duotone" />,
        // },
        {
            id: "government_id",
            placeholder: "اختر محافظتك",
            type: "select",
            options: governments,

            className: "lg:col-span-2",
        },
    ];
    if (isMultiYear) {
        const toUseYears = years.filter((value, index) => index < 3);

        inputFields = [
            ...inputFields,
            {
                id: "year",
                placeholder: "اختر الصف الدراسي",
                type: "select",
                options: toUseYears,

                className: "lg:col-span-2",
            },
        ];
    }
    inputFields = [
        ...inputFields,
        {
            id: "email",
            placeholder: "البريد الإلكتروني",
            icon: <InputIcon icon="bx:at" />,

            className: "lg:col-span-2",
        },
        {
            id: "password",
            placeholder: "كلمة السر",
            icon: <InputIcon icon="ri:lock-password-fill" />,
        },
        {
            id: "password_confirmation",
            placeholder: "تأكيد كلمة السر",
            icon: <InputIcon icon="ri:lock-password-fill" />,
        },
        {
            id: "national_id_copy",
            placeholder: "ارفع شهادة ميلادك / بطاقتك",
            type: "file",
            icon: <InputIcon icon="icon-park-twotone:id-card" />,

            className: "lg:col-span-2",
        },
    ];

    const handleSubmit = (e) => {
        handleFormSubmit(e, setIsLoading, setErrors, registerUser);
    };

    const navigate = useNavigate();

    const { state } = useLocation();

    const redirect = (certainPath = false) => {
        if (certainPath) {
            navigate(certainPath);
        } else {
            if (!state) {
                navigate("/home");
            } else {
                navigate(state.prevPath);
            }
        }
    };
    const registerUser = async () => {
        try {
            await http.get("/sanctum/csrf-cookie");
            const visitorVisitId = a.getVisitorVisit();
            const toSendUser = { ...user, visitor_visit_id: visitorVisitId };
            toSendUser["phone"] = parseInt(user["phone"]);
            toSendUser["father_phone"] = parseInt(user["father_phone"]);
            toSendUser["mother_phone"] = parseInt(user["mother_phone"]);

            const formData = getFormData(toSendUser);

            const result = await http.post("api/auth/account_creation_request", formData);
            // auth.authenticates(result.data.token, result.data.user);
            // setAccountRequest({
            //     ...result.data.user,
            // });

            setIsLoading(false);
            modal.message({
                title: `أهلا ${user.first_name}`,

                // تم إنشاء حسابك و سيتم مراجعته من خلال فريق الدعم
                // تقدر تسجل دخول خلال ٤٨ ساعة`,
                text: "الطلب بتاعك دلوقتي في حالة المراجعة من فريق الدعم و هيتم الرد عليك في خلال اسرع وقت",
                callback: () => {
                    setAccountRequest({
                        ...result.data.user,
                    });
                    redirect("/account_creation_status");
                },
            });
        } catch ({ response }) {
            handleFormErrors(response, setIsLoading, setErrors);
        }
    };

    return (
        <SigningForm
            className="space-y-6"
            headTitle={"طلب انشاء حساب :"}
            headIcon={registerPageIcon}
            beforeLogin={
                <div className=" mx-auto  min-w-[50%]">
                    <Button
                        element="a"
                        href="https://youtu.be/OelfBZqG5Cg?si=nWhpC-310hMxk7P0"
                        className="inline-block text-center w-full md:w-3/4"
                        target="_blank"
                        color="orange"
                    >
                        طريقة انشاء حساب
                        <br />
                        علي منصة وليد محسن
                    </Button>
                </div>
            }
            picture={registerPicture}
            description={"ادخل بياناتك بشكل صحيح وسيتم التواصل معاك في اسرع وقت لتفعيل الحساب !"}
            onSubmit={handleSubmit}
            fields={
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-6">
                    {inputFields.map((input, key) =>
                        renderInputFields(
                            key,
                            input.handleChange ? input.handleChange : handleChange,
                            user,
                            setUser,
                            errors,
                            input
                        )
                    )}
                </div>
            }
            color={registerPageColor}
            secondaryColor={loginPageColor}
            buttonTitle="طلب انشاء حساب !"
            isLoading={isLoading}
            altLink={"/login"}
            alt="يوجد لديك حساب بالفعل؟"
            altColored={"ادخل إلى حسابك الآن !"}
        />
    );
};

export default AccountCreationRequest;
